import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import Modal from "react-bootstrap/Modal";
import * as constantMessages from "../../constants/constatntMessages";
import { checkCharacterLeft } from "../../helpers/commonHelpers";
import LoaderButton from "../Common/LoaderButton";
import SmallLoaderButton from "../Common/SmallLoaderButton";
const regularExpressionForAgendaTitle =
  /^[0-9a-zA-Z .,:\n;%@&#!$^*+=`~()/_'"\\\-?|{}\[\]]+$/;

const CancelMeetingModal = React.memo((props) => {
  const [remark, setRemark] = useState("");
  const [errors, setErrors] = useState({});
  const handleSubmit = () => {
    const newErrors = validateForm();
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      props.handleSubmit(remark);
      setRemark("");
    }
  };
  const validateForm = () => {
    const errors = {};
    if (!remark.trim()) {
      errors.remark = constantMessages.remarksRequired;
    } else if (!regularExpressionForAgendaTitle.test(remark.trim())) {
      errors.remark = constantMessages.titleRegexError;
    } else if (remark.trim().length < 3 || remark.trim().length > 500) {
      errors.remark = constantMessages.largeStringLengthError;
    }
    setErrors(errors);
    return errors;
  };

  const closeModal = () => {
    setRemark("");
    props.setIsModalOpen(false);
  };

  return (
    <>
      <Modal show={props.isModalOpen} onHide={closeModal} backdrop="static">
        <div className="modal-header">
          <h4 className="modal-title">Meeting Cancellation Remark</h4>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeModal}
          ></button>
        </div>
        <div className="modal-body delete-txt">
          <label className="mb-1">
            Cancellation Remark
            <span className="star-mark"> *</span>
          </label>
          <textarea
            cols="40"
            rows="4"
            id="remark"
            name="remark"
            onBlur={validateForm}
            onChange={(e) => setRemark(e.target.value)}
            value={remark}
            placeholder="Enter your remarks here..."
            required
          ></textarea>
          <p className="success-message">
            {checkCharacterLeft(remark)} Characters left
          </p>
          {errors.remark && (
            <span className="error-message">{errors.remark}</span>
          )}
        </div>

        <div className="modal-footer">
          {props?.isLoading ? (
            <SmallLoaderButton />
          ) : (
            <button
              type="button"
              onClick={handleSubmit}
              className="Mom-btn btn btn-secondary bg-primary border-primary"
            >
              <p>Submit Remark</p>
            </button>
          )}
        </div>
      </Modal>
    </>
  );
});

export default CancelMeetingModal;
